import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { Check, CheckCircle2, GripVertical, RotateCcw } from 'lucide-react';

const TimelineElement = ({ config, element, onComplete, onSaveData, isCompleted }) => {
  const tc = config || {};
  const correctOrder = (tc.events || []).map(e => e.label);
  const [items, setItems] = useState(() => [...correctOrder].sort(() => Math.random() - 0.5));
  const [checked, setChecked] = useState(false);
  const [dragIdx, setDragIdx] = useState(null);

  const handleDragStart = (idx) => setDragIdx(idx);
  const handleDrop = (targetIdx) => { if (dragIdx === null) return; const updated = [...items]; const [moved] = updated.splice(dragIdx, 1); updated.splice(targetIdx, 0, moved); setItems(updated); setDragIdx(null); };
  const handleCheck = () => { setChecked(true); const allCorrect = items.every((item, i) => item === correctOrder[i]); onSaveData({ order: items, correct: allCorrect }); if (allCorrect && !isCompleted) { onComplete(); toast.success('Correct order!'); } };
  const handleRetry = () => { setChecked(false); setItems([...correctOrder].sort(() => Math.random() - 0.5)); };

  return (
    <div className="space-y-4" data-testid="timeline-element">
      {tc.instructions && <p className="text-sm text-slate-600 italic">{tc.instructions}</p>}
      <div className="space-y-2">
        {items.map((item, i) => {
          const isCorrect = checked && item === correctOrder[i];
          const isWrong = checked && item !== correctOrder[i];
          return (
            <div key={`${item}-${i}`} draggable={!checked || isWrong} onDragStart={() => handleDragStart(i)} onDragOver={(e) => e.preventDefault()} onDrop={() => handleDrop(i)} className={`flex items-center gap-3 p-3 rounded-lg border-2 cursor-grab active:cursor-grabbing transition-colors ${isCorrect ? 'border-green-300 bg-green-50' : isWrong ? 'border-red-300 bg-red-50' : 'border-slate-200 bg-white hover:border-[#20acf6]/40'}`}>
              <GripVertical className="h-4 w-4 text-slate-300 shrink-0" />
              <span className="text-xs font-bold text-slate-400 w-5">{i + 1}.</span>
              <span className="text-sm flex-1">{item}</span>
              {isCorrect && <CheckCircle2 className="h-4 w-4 text-green-600" />}
              {isWrong && <span className="text-xs text-red-500 font-medium">Wrong position</span>}
            </div>
          );
        })}
      </div>
      {!checked ? (<Button onClick={handleCheck} className="bg-[#20acf6] hover:bg-[#3bb8f7]" data-testid="check-timeline-btn"><Check className="h-4 w-4 mr-2" /> Check Order</Button>) : !items.every((item, i) => item === correctOrder[i]) && (<Button onClick={handleRetry} variant="outline" data-testid="retry-timeline-btn"><RotateCcw className="h-4 w-4 mr-2" /> Try Again</Button>)}
    </div>
  );
};

export default TimelineElement;
